import AsyncStorage from "@react-native-async-storage/async-storage";
import type { TokenStore } from "@axio/auth";

const accessTokenSlot = "accessToken";
const refreshTokenSlot = "refreshToken";

export const createRNTokenStore = (): TokenStore => {
  return {
    getAccessToken: () => AsyncStorage.getItem(accessTokenSlot),
    getRefreshToken: () => AsyncStorage.getItem(refreshTokenSlot),
    setTokens: async ({ accessToken, refreshToken }) => {
      await AsyncStorage.multiSet([
        [refreshTokenSlot, refreshToken],
        [accessTokenSlot, accessToken],
      ]);
    },
    setAccessToken: (accessToken: string) => AsyncStorage.setItem(accessTokenSlot, accessToken),
    clearTokens: () => AsyncStorage.multiRemove([accessTokenSlot, refreshTokenSlot]),
  };
};
